import useTraces from "@/hooks/useTraces";
import useUsers from "@/hooks/useUsers";
import { Box } from "@mui/material";
import { FC } from "react";
import Trace from "./Trace";
import UserPoint from "./UserPoint";

interface TraceLayerProps {
  /**
   * Make the traces selectable or not.
   */
  selectable: boolean;
}

const TraceLayer: FC<TraceLayerProps> = ({ selectable }) => {
  const { usersById, users } = useUsers();
  const { traces } = useTraces();

  return (
    <Box>
      {/* users coordinate (if no trace active) */}
      {users
        .filter((user) => user.traces?.filter((trace) => trace.isActive)?.length === 0)
        .map((user) => (
          <UserPoint key={`user-coordinate-${user.id}`} user={user} />
        ))}
      {traces.map((trace, i) => {
        const user = trace.userId ? usersById[trace.userId] ?? null : null;

        return <Trace key={`${trace.id} ${i}`} user={user} trace={trace} selectable={selectable} />;
      })}
    </Box>
  );
};

export default TraceLayer;
